/**
 * Import Dependency
 */
import { handleActions } from 'redux-actions'

/**
 * Export
 */
export const promocodes = handleActions({
  UPDATE_PROMOCODES: (state, action) => {
    return action.payload
  },
}, null)

export default {
  promocodes,
}



// WEBPACK FOOTER //
// ./src/reducers/components/promocodes.js